import {observable, action, computed} from 'mobx';

class Pagination {
  @observable total;

  @observable limit = 10;

  @observable currentPage = 0;

  @computed get pagination() {
    return {
      total: this.total,
      current: this.currentPage + 1,
      pageSize: this.limit
    };
  }

  initPaginationRequestBody = {
    currentPage: 0,
    limit: 10
  };

  get paginationRequestBody() {
    const {currentPage, limit} = this;
    return {
      currentPage,
      limit
    };
  }

  get paginationRequestBodyBefore() {
    const {limit, currentPage} = this;
    return {
      currentPage: currentPage ? currentPage - 1 : 0,
      limit
    };
  }

  changePagination(pagination) {
    this.limit = pagination.pageSize;
    this.currentPage = pagination.current - 1;
  }

  @action('设置分页')
  setPagination(data) {
    let info = data;
    if (!info) {
      info = {limit: 10, currentPage: 0, total: 0};
    }
    this.limit = info.limit;
    this.currentPage = info.currentPage;
    this.total = info.total;
  }
}

export default Pagination;
